module.exports = __webpack_public_path__ + "img/Pop-up.2e21a7c0.png";